// extracted by mini-css-extract-plugin
module.exports = {"postList":"postList-module--postList--1fqvn","modernizrNoCssgrid":"postList-module--modernizr-no-cssgrid--14_Br"};